// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__SWfwm","colCheckbox":"styles_colCheckbox__1QBK4"};